import { render, staticRenderFns } from "./OrdersChart.vue?vue&type=template&id=4d89a06e"
import script from "./OrdersChart.vue?vue&type=script&lang=js"
export * from "./OrdersChart.vue?vue&type=script&lang=js"
import style0 from "./OrdersChart.vue?vue&type=style&index=0&id=4d89a06e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports